export default __webpack_public_path__ + "static/media/toyota-box.8968332b.png";